import { ocrSignal } from "../../OCR/ocr.signal";
import OCRRender from "../../OCR/OCRRender";
import { Alert } from "react-bootstrap";
import { useEffect } from "react";
import applicationDetailSignal from "../ApplicationDetail.signal";
import { fetchRawOcrData } from "../ApplicationDetail.helpers";
import {
  formatOcrDataForSubmit,
  getOcrCategoriesToRender,
  hydrateFormattedOcrDataForMergedPairedFields,
  applyAnalystSignatureConfirmFields,
  parseOcrData,
} from "../../OCR/ocr.helpers";

const ApplicationFormTab = () => {
  const { fundingProgram, rawOcr, formData, applicationConfig } =
    applicationDetailSignal.value;

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      const parsedOcrData = applyAnalystSignatureConfirmFields(
        (applicationConfig?.parsedOcrData as Record<string, unknown>) || {},
        formData
      );
      const modelId =
        fundingProgram?.ocrModelKey ||
        (applicationConfig?.ocrModelKey as string) ||
        "";
      /** Same ordering as OCRRender / parse — do not rely on persisted `sortedCategories` alone. */
      const sortedCategories = getOcrCategoriesToRender(parsedOcrData, modelId);
      /** Merged Yes/No dropdowns are stored as `_yes`/`_no` in formData; read-only UI keys by merged name. */
      const formattedOcrData = hydrateFormattedOcrDataForMergedPairedFields(
        formData,
        parsedOcrData
      );

      ocrSignal.update({
        formattedOcrData,
        sortedCategories,
        parsedOcrData,
        modelId,
      });
    } else if (applicationConfig?.isUsingOcr) {
      fetchRawOcrData();
    }
  }, [formData, applicationConfig, fundingProgram]);

  useEffect(() => {
    if (rawOcr) {
      ocrSignal.update({
        modelId: fundingProgram?.ocrModelKey || '',
        rawOcrData: rawOcr,
      });
      parseOcrData();
      formatOcrDataForSubmit();
      const { formattedOcrData, parsedOcrData } = ocrSignal.value;
      ocrSignal.update({
        formattedOcrData: hydrateFormattedOcrDataForMergedPairedFields(
          formattedOcrData,
          parsedOcrData
        ),
      });
    }
  }, [rawOcr, fundingProgram?.ocrModelKey]);

  if (!Object.keys(ocrSignal.value.formattedOcrData).length) {
    return (
      <div className="pt-40">
        <Alert className="text-center" variant="warning">
          No application form data was found.
        </Alert>
      </div>
    );
  }

  return (
    <div className="pt-40">
      <OCRRender readOnly />
    </div>
  );
};

export default ApplicationFormTab;
